// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageSwitcher_container__vHlnx"};